export const mutations = {
  SET_AUTH(state, userData) {
    state.api_token = userData.token
    state.user_name = userData.userName
  },
  REMOVE_AUTH(state) {
    state.api_token = null
    state.user_name = null
  },
  SET_REQUEST_COMPLETE(state, status) {
    state.request_complete = status
  },
  SET_CURRENCY(state, currency) {
    state.yipps_currency = currency
  },
  SET_USER_AVATAR(state, avatarURL) {
    state.user_avatar_url = avatarURL
  }
}
